module.exports = __webpack_public_path__ + "static/img/6.6c4daa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/eng/6.png
// module id = YaHE
// module chunks = 0